import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20.4849 15.535L11.9999 7.04999L3.51486 15.535L4.92886 16.95L11.9999 9.87799L19.0709 16.95L20.4849 15.535Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronBigUp"
);
